import { prefixObjectValues as pre } from '../../../utils';
const prefix = 'address-card';

// [MCV-1332] Mobile stacked-card layout (shown below the table breakpoint).
const card = pre(
  {
    row: 'row-',
  },
  prefix
);

export default card;
